export default __webpack_public_path__ + "static/media/insurance.b3eacf81.svg";